import React from 'react'
export const degen = {
  path: (
    <>
      <circle cx="16" cy="16" r="13" fill="url(#paint0_linear_14937_4240)" />
      <g clipPath="url(#clip0_14937_4240)">
        <path
          d="M10.3359 17.4846L10.4004 18.5953C10.4047 18.671 10.4347 18.7421 10.4853 18.8004C10.8393 19.2054 12.4262 20.6182 16.0024 20.6182C19.5787 20.6182 21.1464 19.2236 21.5135 18.808C21.5688 18.7453 21.6007 18.6674 21.6059 18.5855L21.6698 17.4853C22.0956 17.2646 22.5351 17.0152 22.5351 17.0152C23.2262 16.6614 23.9974 17.1696 23.9988 17.9149C24.0011 19.1208 23.0039 20.3601 21.6589 21.1411C20.1422 22.0217 17.8783 22.387 16.0034 22.387C14.1286 22.387 11.8646 22.0217 10.348 21.1411C9.00291 20.3601 8.00572 19.1213 8.00806 17.9149C8.00947 17.1696 8.78069 16.6614 9.47173 17.0152C9.47173 17.0152 9.9105 17.264 10.3359 17.4846Z"
          fill="#472A91"
        />
        <path
          d="M16.0029 9.60205C18.9269 9.60205 19.7197 9.66657 20.9087 9.79562H20.9082C21.4563 9.85525 21.8956 10.2406 21.8548 10.7626L21.4168 16.3998C21.2798 16.4373 21.1303 16.4847 20.9627 16.5379C20.0843 16.8164 18.7072 17.2531 16.0029 17.2531C13.2985 17.2531 11.9215 16.8164 11.043 16.5379C10.8752 16.4847 10.7256 16.4372 10.5885 16.3997L10.1505 10.7626C10.1102 10.2406 10.5481 9.8459 11.0971 9.79562C12.2715 9.68793 13.4942 9.60205 16.0029 9.60205ZM10.7983 19.1009L10.7999 19.1207L10.8301 19.1273C10.8193 19.1184 10.8087 19.1096 10.7983 19.1009ZM21.1782 19.1266L21.2055 19.1207L21.2069 19.1027C21.1975 19.1106 21.1879 19.1186 21.1782 19.1266Z"
          fill="#472A91"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_14937_4240"
          x1="7"
          y1="6"
          x2="22.5"
          y2="25"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9B70F5" />
          <stop offset="1" stopColor="#7D48EA" />
        </linearGradient>
        <clipPath id="clip0_14937_4240">
          <rect width="16" height="12.8" fill="white" transform="translate(8 9.6001)" />
        </clipPath>
      </defs>
    </>
  ),
  viewBox: '0 0 32 32',
}
